
<n-editor-button
  icon="drag-handle"
  :aria-label="$t('general.dragHandle')"
  :class="hidden && 'hide'"
  @click="$emit('click', $event)"
  @touchstart="$emit('click')"
  :disabled="hidden && !focusable"
/>
